import LedByCommunityContextProvider from './LedByCommunityContextProvider'
import { LedByCommunityList } from './LedByCommunityList'

export const LedByCommunity = ({ search }: { search: string }) => (
  <LedByCommunityContextProvider>
    <LedByCommunityList search={search} />
  </LedByCommunityContextProvider>
)
